var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topban"},[_c('div',{staticClass:"con"},[_c('span',[_vm._v("郑州方程世纪数码信息技术有限公司")])])])}]

export { render, staticRenderFns }